import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Image } from "react-bootstrap";
import styled, { css } from 'styled-components';
import { FacebookFooter, InstaFooter, TwitterFooter, LinedInFooter } from '../../../components/icons';
import api from '../../../services/client';
import { useParams } from 'react-router-dom';
import parse from "html-react-parser";
import BannerImage from '../../../assets/JobDetails_banner.png';
import {IoLocation} from 'react-icons/io5'

const JDContainer = styled.div`
   display: flex;
   flex-direction: column;
   background-color: #F9F9F9;
   border-radius: 20px;
   border-left: 3px solid #0A3BB4;
   box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
   margin: 25px 0;
   margin-left: 10%;
`;

const SocialLinks = styled.div`
    margin: 20px 0px;
`;

const ApplyButton = styled.a`
background-color: #0A3BB4;
border: none;
color: white;
padding: 10px;
text-align: center;
text-decoration: none;
display: inline-block;
font-size: 16px;
border-radius: 20px;
margin: 10px 0px;
margin-left: 50%;
text-decoration: none;

&:hover {
    color: white
}
`

const JDRow = styled(Row)`
    margin:3% 8%;
    font-size: 16px;
    color: #707070;
    font-family: 'robot regular';
    ${props =>
        props.index === '1' &&
        css`
            margin-top: 8%;
        `};
`;

const JDCol = styled(Col)`
${props =>
        props.header &&
        css`
      font-weight: bold;
      font-size: 16;
      color: #111111;
      font-family: 'robot regular';
    `};
`;

const Hr = styled.hr`
width: 65%;
margin-left: 15%;
background-image: 'linear-gradient(180deg, rgba(17,17,17,1) 0%, rgba(249,249,249,1) 15%, rgba(0,0,0,1) 100%);';
`;

const CompDetailContainer = styled.div`
text-align: center;
`;

const FB = styled(FacebookFooter)`
    margin:0px 0 0 10px;
    width:20px;
    height:20px;
`;

const Twitter = styled(TwitterFooter)`
    margin: 0px 0 0 10px;
    width:20px;
    height:20px;
`;

const Insta = styled(InstaFooter)`
    margin: 0px 0 0 10px;
    width:20px;
    height:20px;
`;

const Linkedin = styled(LinedInFooter)`
    margin: 0px 0 0 10px;
    width:20px;
    height:20px;
`;

const GradientDiv = styled.div`
height: 15px;
margin: 20px 0px;
background-image: linear-gradient(to top,rgba(255,0,0,0),rgba(192,192,192,0.5),rgba(255,0,0,0));
`

const Banner = styled.div`
background-image: url(${BannerImage});
    min-height: 540px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    @media screen and (max-width: 780px) {
        min-height: 300px;
    }
`;

const TitleOnBanner = styled(Row)`
    position: absolute;
    bottom: 15%;
    width: 40%;
    left: 40%;
    color: white;

    ${props =>
        props.header &&
        css`
        bottom: 25%;
        font-size: 76px;
    `};
`;

// style='margin-top: 15px;width: 70%;'
// style={{width:"80%"marginLeft: 10%"}}'
function JobDetails() {

    const { jobId } = useParams();
    const [jobDetail, setJobDetail] = useState({});
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        api.getJobDetails(jobId).then(result => {           
            setJobDetail(result.data);
            setShowForm(true);
        }).catch(error => {
            debugger;
        });
    },[]);

    return showForm && jobDetail && (
        <>
        <Banner>
            <TitleOnBanner header>
                {jobDetail.Title}
            </TitleOnBanner>
           <TitleOnBanner>
               <Col sm='2'><IoLocation fill='gray' /> {jobDetail?.Location}</Col>
               <Col sm='2'><span>{jobDetail?.Type}</span></Col>
               <Col sm='4'><span style={{color:'lightgray'}}>Company: </span>{jobDetail?.Company?.CompanyName}</Col>
               <Col sm='4'><span style={{color:'lightgray'}}>Classification: </span>{jobDetail?.Category}</Col>
           </TitleOnBanner>
        </Banner>
        <Container style={{ marginTop: "15px", width: "65%", marginBottom: '5%' }}>
            <ApplyButton href={jobDetail.FullLink}>Apply for this job</ApplyButton>
            <JDContainer>
                <JDRow index='1'>
                    <JDCol sm='2' header>Overview</JDCol>
                    <JDCol sm='10'>
                        {jobDetail?.Description && parse(jobDetail?.Description)}
                    </JDCol>
                </JDRow>
                <Hr />
                <JDRow>
                    <JDCol sm='2' header>What you'll be doing</JDCol>
                    <JDCol sm='10'>
                        {jobDetail?.Objective && parse(jobDetail?.Objective)}
                    </JDCol>
                </JDRow>
                <Hr />
                <JDRow>
                    <JDCol sm='2' header>What we offer</JDCol>
                    <JDCol sm='10'>
                        {jobDetail?.Offers && parse(jobDetail?.Offers)}
                    </JDCol>
                </JDRow>
                <Hr />
                <JDRow>
                    <JDCol sm='2' header>Who Should Apply?</JDCol>
                    <JDCol sm='10'>
                        {jobDetail?.WhoShouldApply && parse(jobDetail?.WhoShouldApply)}
                    </JDCol>
                </JDRow>
                <Hr />
                <JDRow>
                    <JDCol sm='2' header>What Next?</JDCol>
                    <JDCol sm='10'>
                        {jobDetail?.WhatNext && parse(jobDetail?.WhatNext)}
                    </JDCol>
                </JDRow>
                <CompDetailContainer>
                    <GradientDiv/>
                    <h3>ABOUT COMPANY</h3>
                    <span>
                        {jobDetail?.Company?.CompanyDescription && parse(jobDetail?.Company?.CompanyDescription)}
                    </span>
                    <SocialLinks>
                        <FB /> <Twitter /> <Linkedin /> <Insta />
                    </SocialLinks>
                </CompDetailContainer>
            </JDContainer>
            <ApplyButton href={jobDetail.FullLink}>Apply for this job</ApplyButton>
        </Container>
        </>
    )
}

JobDetails.propTypes = {
}

export default JobDetails

